import { Component, OnInit, Input, Output, EventEmitter, HostBinding } from '@angular/core';
import { Project } from '../../models/project';

@Component({
  selector: 'cw-client-projects-tree-item',
  templateUrl: 'client-projects-tree-item.component.html',
})
export class ClientProjectsTreeItemComponent implements OnInit {
  @Input() project: Project;
  @Input() selected: Project;
  @Output() select: EventEmitter<Project> = new EventEmitter<Project>();

  @HostBinding('class.is-selected')
  get isSelected() {
    if (!this.selected) {
      return false;
    }

    return this.selected.id === this.project.id;
  }

  constructor() {
  }

  ngOnInit() {
  }

  toggleSelected() {
    //this.isSelected = !this.isSelected;
    this.select.emit(this.project);
  }

  onChildSelected(project: Project) {
    console.log('apa');
    this.select.emit(project);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/client-projects-tree/client-projects-tree-item.component.ts